export default __webpack_public_path__ + "static/media/attach.2de124a9.svg";